
// 从 variants 中找到所有有货的 value_index

interface SpecCombination {
  id: string;
  specs: string[];
}

// specCombinationList form variants
// instock [
//   { id: '1', specs: [ '5589', '8801' ] },
//   { id: '2', specs: [ '5597', '8802' ] },
//   { id: '3', specs: [ '5511', '8801' ] },
//   { id: '4', specs: [ '5511', '8800' ] },
//   { id: '5', specs: [ '5511', '8799' ] },
//   { id: '6', specs: [ '5515', '8800' ] },
// ]
export const getSpecCombinationListFromVariants = (variants: any[]): SpecCombination[] => {

  // in stock or pre order
  const couldBuy = variants
    .filter(variant => variant.product.stock_status === "IN_STOCK" || variant?.product?.presale_product?.status)

  return couldBuy
    .map((variant, index) => ({
      id: (index + 1).toString(),
      specs: variant.attributes.map((attr: any) => attr.value_index.toString())
    }));
};


export const getSpecListFromConfigurableOptions = (configurableOptions: any) => {
  return configurableOptions.map((option: any) => {
    return {
      title: option.label,
      list: option.values.map((value: any) => value.value_index.toString())
    }
  })
}

export const getExistingOptionValues = (variants: any[], configurableOptions: any[]) => {
  const existingValues: Record<string, Set<string>> = {};

  configurableOptions.forEach(option => {
    existingValues[option.attribute_code] = new Set();
  });

  variants.forEach(variant => {
    variant.attributes.forEach((attr: any) => {
      if (existingValues[attr.code]) {
        existingValues[attr.code].add(attr.value_index.toString());
      }
    });
  });

  return existingValues;
};
// {
//   title: 'Color',
//   list: [
//     5643, 5447, 5469, 5434,
//     5433, 5515, 5467, 5523,
//     5443, 5431, 5632, 5511,
//     9054, 5597, 5636, 5589,
//     9401
//   ]
// },
// {
//   title: 'Size',
//   list: [
//     8797, 8798, 8799,
//     8800, 8801, 8802,
//     8803, 8804, 8805
//   ]
// }
// ]
